export default __webpack_public_path__ + "locales/hy-AM/Common.json?hash=3f384fed5fe2763dafb297aad6329b96";